<template>
    <div class="main-container">
        <div class="status ok" v-if="status == 'OK'">
            <h3><i class="fal fa-check-circle"></i></h3>
            <h3>پرداخت موفق</h3>

            <router-link tag="button" :to="{ name: 'Khanesh' }" class="btn btn-dark">بازگشت به خانه</router-link>
            <router-link tag="button" :to="{ name: 'MyWealth' }" class="btn btn-outline-dark">بارگشت به کیف پول</router-link>
        </div>
        <div class="status nok" v-else>
            <h3><i class="fal fa-times-circle"></i></h3>
            <h3>پرداخت ناموفق</h3>

            <router-link tag="button" :to="{ name: 'Khanesh' }" class="btn btn-dark">بازگشت به خانه</router-link>
            <router-link tag="button" :to="{ name: 'MyWealth' }" class="btn btn-outline-dark">بارگشت به کیف پول</router-link>
        </div>
    </div>
</template>

<script>
import { postRequest } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';

export default {
    name: 'PaymentStatus',
    mounted() {
        if(this.amount && this.authority && this.isCourse == 'NOK') {
            postRequest('/users/payment-verify', {
                Amount: this.amount,
                Authority: this.authority,
            })
                .then(() => {
                // response
                })
                .catch(err => {
                // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' })
                        }
                    }
                });
        } else if (this.isCourse == 'OK') {
            postRequest('/users/course-verify', {
                Amount: this.amount,
                Authority: this.authority,
                userId: this.userId,
                courseId: this.courseId,
            })
                .then(() => {
                // response
                })
                .catch(err => {
                // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' })
                        }
                    }
                });
        }
    },
    data() {
        return {
            status: this.$route.query.Status,

            amount: this.$route.query.Amount,
            authority: this.$route.query.Authority,

            userId: this.$route.query.userId,
            courseId: this.$route.query.courseId,
            isCourse: this.$route.query.isCourse,
        }
    }
}
</script>

<style scoped>
/* ------------------------------------------- */
/* ----------------- GENERAL ----------------- */
/* ------------------------------------------- */
.main-container {
    padding: 5pt 0;
    display: flex;
}
.main-container .status {
    min-height: 150pt;
    width: 90%;
    max-width: 600px;

    margin: auto;
    padding: 15pt 20pt;

    text-align: center;

    background-color: #f9f9f9;
    border: 1pt solid #ddd;
    border-radius: 5pt;

    -webkit-box-shadow: 2px 2px 12px 5px rgba(238,238,238,1);
    -moz-box-shadow: 2px 2px 12px 5px rgba(238,238,238,1);
    box-shadow: 2px 2px 12px 5px rgba(238,238,238,1);
}
.main-container .status button {
    margin: 5vh 5pt 5pt;
}
.ok h3 {
    color: green;
}
.ok a {
    color: #000;
    font-weight: bold;
}
.ok .persian-num {
    font-family: 'iransans-fa';
}
.nok h3 {
    color: red;
}
</style>
